import { atom } from "recoil";

export const materialBtnDataState = atom({
  key: "materialBtnDataState",
  default: [],
});
